/**
 * Form select options for all forms in the application.
 * Filter/search panel options live in filter-constants.ts.
 */

/** Shared type for all { value, label } select option arrays. */
export interface SelectOption {
  value: string;
  label: string;
}

export const LanguagesOptions = [
  "Amharic",
  "Egyptian Arabic",
  "English",
  "French",
  "Haitian Creole",
  "Hindi",
  "Hmong",
  "Italian",
  "Japanese",
  "Korean",
  "Mandarin Chinese",
  "Portuguese",
  "Romanian",
  "Russian",
  "Somali",
  "Spanish",
  "Standard German",
  "Tamil",
  "Telugu",
  "Urdu",
];

export const GenderIdentityOptions: SelectOption[] = [
  { value: "Identifies as Male", label: "Male" },
  { value: "Identifies as Female", label: "Female" },
  { value: "Non-binary gender identity", label: "Non-binary gender identity" },
  { value: "Transgender Male/Female-to-Male (FTM)", label: "Transgender male" },
  {
    value: "Transgender Female/Male-to-Female (MTF)",
    label: "Transgender female",
  },
  {
    value: "Gender non-conforming (neither exclusively male nor female)",
    label: "Gender non-conforming",
  },
  { value: "Choose not to disclose", label: "Choose not to disclose" },
];

export const PreferredPronounsOptions: SelectOption[] = [
  { value: "He/Him", label: "He/Him" },
  { value: "She/Her", label: "She/Her" },
  { value: "They/Them", label: "They/Them" },
];

export const PhoneTypeOptions: SelectOption[] = [
  { value: "mobile", label: "Mobile" },
  { value: "home", label: "Home" },
  { value: "work", label: "Work" },
];

export const PreferredContactMethodOptions: SelectOption[] = [
  { value: "Email", label: "Email" },
  { value: "Phone/SMS", label: "Phone/SMS" },
];

export const YesNoOptions: SelectOption[] = [
  { value: "yes", label: "Yes" },
  { value: "no", label: "No" },
];

/** @deprecated Use YesNoOptions instead */
export const VoicemailPreferenceOptions = YesNoOptions;

export const PaymentMethodOptions: SelectOption[] = [
  { value: "insurance", label: "Insurance" },
  { value: "self_pay", label: "Self-pay" },
];

export const RelationshipOptions: SelectOption[] = [
  { value: "spouse", label: "Spouse" },
  { value: "child", label: "Child" },
  { value: "other", label: "Other" },
];

/** Gender options as displayed on an insurance policy (full string values, distinct from LegalSexOptions). */
export const LegalSexOptions: SelectOption[] = [
  { value: "m", label: "Male" },
  { value: "f", label: "Female" },
];
